import { render, staticRenderFns } from "./LprGatedParking.vue?vue&type=template&id=129a687e&"
import script from "./LprGatedParking.vue?vue&type=script&lang=js&"
export * from "./LprGatedParking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports